import {
  Currency,
  GetProductCardsQueryVariables,
  Iso639,
} from "../../../graphql/operations";
import { CollapsibleContainerRef } from "mt-components/CollapsibleContainer/CollapsibleContainer";
import { MutableRefObject } from "react";

export const scrollToCollapsibleContainer = (
  containerRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>,
  navigationRef: MutableRefObject<HTMLDivElement>,
  isMobile?: boolean,
) => {
  const header = document.getElementById("AppHeader");

  const scrollOffset =
    navigationRef.current.getBoundingClientRect().height +
    (isMobile ? header.getBoundingClientRect().height : 0);

  if (containerRef?.current) {
    if ("open" in containerRef.current) containerRef.current.open();

    const elementTop =
      ("container" in containerRef.current
        ? containerRef.current.container
        : containerRef.current
      ).getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: elementTop - scrollOffset,
      behavior: "smooth",
    });
  }
};

// The product page's availability calendar is cached by the browser (Cache-Control)
// for this long, in seconds, and refetched when the visitor comes back to the page
// after it (revalidateIfStale). Checkout fetches it again, and seats are checked again
// when booking.
export const CALENDAR_AVAILABILITY_CACHE = {
  mode: "browser",
  ttl: 60,
  revalidateIfStale: true,
} as const;

// Server-side cache lifetime, in seconds, of the product cards below the product
// page (similar tours, other tours in the city).
export const PRODUCT_CARDS_TTL = 3600;

export const SIMILAR_PRODUCTS_LIMIT = 6;
export const OTHER_TOURS_IN_CITY_LIMIT = 9;

// Variables of the product cards' query. The product page's getStaticProps prefetches
// the cards with these (in USD), so the components must build theirs the same way.
export function productCardsVariables({
  offset = 0,
  limit,
  tags,
  locationId,
  currency,
}: {
  offset?: number;
  limit?: number;
  tags?: string[];
  locationId?: string;
  currency: Currency;
}): GetProductCardsQueryVariables {
  return { offset, limit, tags, language: Iso639.En, locationId, currency };
}
